/* istanbul ignore file */

import dynamic from 'next/dynamic';

import { TileCarouselBlockProps } from 'src/components/blocks/TileCarouselBlock';
import { ContentBlockRenderer } from '../../../types/Block';
import { Transformer } from '../../../types/Transformer';
import { tiles } from './data';
import { FakeTileCarouselContentSection } from './types';

/* istanbul ignore next */
export const renderer: ContentBlockRenderer<TileCarouselBlockProps> =
  dynamic<TileCarouselBlockProps>(() =>
    import('src/components/blocks/TileCarouselBlock').then((mod) => mod.TileCarouselBlock),
  );

export const transformer: Transformer<
  FakeTileCarouselContentSection,
  TileCarouselBlockProps
> = ({}) => ({
  uid: 'fake-uid',
  props: {
    tiles,
    title: 'Shop by department',
    trackingTitle: 'tile carousel',
  },
});
